/* Premium, non-gamified offer popup. Triggers on scroll depth or exit intent, once per
   session. No scratch mechanic, no countdown, no fake urgency. */
(function () {
  "use strict";
  var root = document.querySelector("[data-vh-pop]");
  if (!root) return;

  var once = root.getAttribute("data-once") !== "false";
  var scrollPct = parseInt(root.getAttribute("data-delay"), 10) || 40;
  var force = new URLSearchParams(window.location.search).get("popup") === "1";
  var shown = false;

  function seen() {
    try { return once && sessionStorage.getItem("vh-pop-seen") === "1"; } catch (e) { return false; }
  }
  function markSeen() {
    try { sessionStorage.setItem("vh-pop-seen", "1"); } catch (e) {}
  }

  function open() {
    if (shown || (seen() && !force)) return;
    shown = true;
    root.classList.add("is-open");
    root.setAttribute("aria-hidden", "false");
    markSeen();
  }
  function close() {
    root.classList.remove("is-open");
    root.setAttribute("aria-hidden", "true");
  }

  root.querySelectorAll("[data-vh-pop-close]").forEach(function (el) {
    el.addEventListener("click", close);
  });

  // Email capture: submit the native Shopify customer form over fetch so the card can
  // swap to the code-reveal step without a page reload. If Shopify answers with its
  // bot-challenge page (detectable via the redirect URL), fall back to a normal submit
  // so the signup still completes — never silently drop the email.
  var form = root.querySelector(".vh-pop__form");
  var offerStep = root.querySelector('[data-vh-pop-step="offer"]');
  var successStep = root.querySelector('[data-vh-pop-step="success"]');
  function showSuccess() {
    if (offerStep) offerStep.hidden = true;
    if (successStep) successStep.hidden = false;
  }
  if (form && offerStep && successStep) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      fetch(form.action, { method: "POST", body: new FormData(form), headers: { Accept: "text/html" } })
        .then(function (r) {
          if (r.url && r.url.indexOf("challenge") !== -1) { form.submit(); return; }
          if (r.ok || r.redirected) { showSuccess(); }
          else { form.submit(); }
        })
        .catch(function () { form.submit(); });
    });
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") close();
  });

  // Returning from a challenged (bot-check) signup: the form already posted, so open
  // straight onto the code-reveal step regardless of the once-per-session flag.
  if (new URLSearchParams(window.location.search).get("customer_posted") === "true") {
    showSuccess();
    shown = true;
    root.classList.add("is-open");
    root.setAttribute("aria-hidden", "false");
    return;
  }

  if (force) { open(); return; }
  if (seen()) return;

  // Trigger on scroll depth.
  var onScroll = function () {
    var scrolled = (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;
    if (scrolled >= scrollPct) {
      open();
      window.removeEventListener("scroll", onScroll);
    }
  };
  window.addEventListener("scroll", onScroll, { passive: true });

  // Trigger on exit intent (desktop only — mouse leaves toward the top of the viewport).
  document.addEventListener("mouseout", function (e) {
    if (!e.relatedTarget && e.clientY <= 0) open();
  });
})();
